import { render, staticRenderFns } from "./AlteracoesContainer.vue?vue&type=template&id=c4a370a0&"
import script from "./AlteracoesContainer.vue?vue&type=script&lang=js&"
export * from "./AlteracoesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VExpandTransition})
